import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import axios from "axios";
import {
  getAxiosConfig,
  getUpdatedImageUrlWithSize,
} from "../../utils/helpers";
import CarasouelImages from "../../components/CarasouelImages";
import { IMG_SERVER_URL } from "../../utils/constant";
import Placeholder from "../../assets/placeholder-600x400.webp";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Grid,
  Box,
  IconButton,
  useDisclosure,
  Button,
} from "@chakra-ui/react";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import useRole from "../../utils/useRole";
import Img from "../../components/Img";
import ImgOptimized from "../../components/ImgOptimized";

const Collections = () => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAll, setIsAll] = useState(null);
  const { isSuperAdmin } = useRole();
  const [imagePopup, setImagePopup] = useState({
    currentIdx: null,
    images: [],
  });
  const [selectedUser, setSelectedUser] = useState(null);
  // const { isOpen, onOpen, onClose } = useDisclosure();

  async function fetchCollections() {
    try {
      setLoading(true);
      const {
        data: { data },
      } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/collection/get-all`,
        getAxiosConfig(),
      );
      setCollections(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchCollections();
  }, []);
  console.log({ collections });

  // Delete collection
  const handleDeleteCollection = async (id) => {
    if (window.confirm("Are you sure you want to delete this collection?")) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_BACK_URL}/api/collection/delete/${id}`,
          getAxiosConfig(),
        );
        fetchCollections();
        toast.success("Collection deleted successfully");
      } catch (error) {
        alert("Failed to delete collection");
      }
    }
  };

  // Open edit modal
  const handleEditCollection = (collection) => {
    // setEditCollection(collection);
    setIsAll(collection);
    // onOpen();
  };

  // Remove image from collection
  const handleRemoveImage = async (imageId) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACK_URL}/api/collection/remove-images/${isAll._id}`,
        { imageId },
        getAxiosConfig(),
      );
      // Update local state
      setIsAll((prev) => ({
        ...prev,
        images: prev.images.filter((img) => img.id !== imageId),
      }));
      // fetchCollections();
      toast.success("Image removed successfully");
    } catch (error) {
      alert("Failed to remove image");
    }
  };
  console.log(isAll?.images?.[imagePopup.currentIdx]);
  let allUsers = [
    ...new Set(
      collections
        .map((c) =>
          c?.name && typeof c?.name == "string"
            ? c.name.split(" - ")?.[1]
            : null,
        )
        .filter((v) => !!v),
    ),
  ];
  console.log(allUsers);
  return (
    <Layout>
      <div className="container mx-auto mt-4 px-4 sm:px-0">
        <div className="flex mb-4 justify-between items-center">
          {/* <div className="flex items-center justify-between w-full"> */}

          <h2 className="text-xl">
            {isAll
              ? isAll.name
              : selectedUser
                ? "All Collections"
                : "All Users"}
          </h2>
          <div className="flex gap-2 items-center">
            {selectedUser && isSuperAdmin && (
              <Button
                size={"sm"}
                colorScheme="teal"
                onClick={() => setSelectedUser(null)}
                variant={"outline"}
              >
                Show All Users
              </Button>
            )}
            {/* </div> */}
            {isAll && (
              <Button
                colorScheme="teal"
                size={"sm"}
                onClick={() => setIsAll(null)}
              >
                Show All Collections
              </Button>
            )}
          </div>
        </div>
        {loading ? (
          <div className="flex items-center justify-center h-96">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
          </div>
        ) : (
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 350: 1, 600: 2, 950: 3, 1100: 4 }}
          >
            {isAll && isAll.images.length > 0 ? (
              <Masonry gutter={"1.2rem"}>
                {isAll.images.map((image, idx) => (
                  <div
                    key={image.id}
                    // position="relative"
                    // borderRadius="md"
                    // borderWidth="1px"
                    // overflow="hidden"
                    className="relative "
                  >
                    <Img
                      src={getUpdatedImageUrlWithSize(
                        `${IMG_SERVER_URL}/brick-img/${image.id}.jpg`,
                        [2, 2, 2],
                      )}
                      alt=""
                      onClick={() =>
                        setImagePopup({ currentIdx: idx, images: isAll.images })
                      }
                      className={
                        "relative item rounded-xl cursor-pointer w-full h-full min-h-[200px]"
                      }
                      // style={{
                      //   width: "100%",
                      //   minHeight: "140px",
                      //   objectFit: "cover",
                      //   borderRadius: "8px",
                      // }}
                    />
                    <button
                      title="Delete Image"
                      onClick={() => handleRemoveImage(image.id)}
                      style={{
                        position: "absolute",
                        top: "6px",
                        right: "6px",
                        background: "#00000030",
                        borderRadius: "50%",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        padding: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "none",
                        cursor: "pointer",
                        transition: "box-shadow 0.2s",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(0,0,0,0.25)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.boxShadow =
                          "0 2px 8px rgba(0,0,0,0.15)")
                      }
                    >
                      <Icon
                        icon="mdi:delete"
                        color="#dc2626"
                        width="16"
                        height="16"
                      />
                    </button>
                  </div>
                ))}
              </Masonry>
            ) : isAll && isAll.images.length === 0 ? (
              <div className="mt-10 text-center text-gray-400 ">
                No images found
              </div>
            ) : !selectedUser && isSuperAdmin ? (
              <div>
                {allUsers.map((user, idx) => (
                  <UserCard
                    key={idx}
                    user={user}
                    onClick={() => setSelectedUser(user)}
                  />
                ))}
              </div>
            ) : (
              <>
                {collections.filter((v) =>
                  selectedUser && isSuperAdmin
                    ? v?.name?.includes(selectedUser)
                    : true,
                ).length == 0 ? (
                  <div className="mt-10 text-center text-gray-400 ">
                    No Collections found
                  </div>
                ) : (
                  <ResponsiveMasonry
                    columnsCountBreakPoints={{
                      350: 1,
                      600: 2,
                      950: 3,
                      1100: 4,
                    }}
                  >
                    <Masonry gutter={"1.2rem"}>
                      {/* <div className="h-full grid grid-cols-4 gap-4 "> */}
                      {collections
                        .filter((v) =>
                          selectedUser && isSuperAdmin
                            ? v?.name?.includes(selectedUser)
                            : true,
                        )
                        .map((v, idx) => (
                          <div
                            key={v._id}
                            className="max-h-52 sm:max-h-[auto]  min-h-40 overflow-hidden flex flex-col border rounded-lg relative cursor-pointer"
                          >
                            <div className="absolute top-2 right-2 flex gap-2 z-[5]">
                              <button
                                onClick={() => handleEditCollection(v)}
                                title="Edit"
                                style={{
                                  background: "#00000050",

                                  borderRadius: "50%",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                  padding: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  border: "none",
                                  cursor: "pointer",
                                  transition: "box-shadow 0.2s",
                                }}
                                onMouseOver={(e) =>
                                  (e.currentTarget.style.boxShadow =
                                    "0 4px 12px rgba(0,0,0,0.25)")
                                }
                                onMouseOut={(e) =>
                                  (e.currentTarget.style.boxShadow =
                                    "0 2px 8px rgba(0,0,0,0.15)")
                                }
                              >
                                <Icon
                                  icon="mdi:pencil"
                                  color="white"
                                  width="20"
                                  height="20"
                                />
                              </button>
                              <button
                                onClick={() => handleDeleteCollection(v._id)}
                                title="Delete"
                                style={{
                                  background: "#00000030",
                                  borderRadius: "50%",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                  padding: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  border: "none",
                                  cursor: "pointer",
                                  transition: "box-shadow 0.2s",
                                }}
                                onMouseOver={(e) =>
                                  (e.currentTarget.style.boxShadow =
                                    "0 4px 12px rgba(0,0,0,0.25)")
                                }
                                onMouseOut={(e) =>
                                  (e.currentTarget.style.boxShadow =
                                    "0 2px 8px rgba(0,0,0,0.15)")
                                }
                              >
                                <Icon
                                  icon="mdi:delete"
                                  color="#dc2626"
                                  width="20"
                                  height="20"
                                />
                              </button>
                            </div>
                            {/* <div className="grow overflow-hidden h-full"> */}
                            <CarasouelImages
                              onClick={() => handleEditCollection(v)}
                              isClickable={true}
                              autoPlaySpeed={Math.random() * 2000 + 2000}
                              images={
                                v.images.length > 0
                                  ? v.images.map((i) =>
                                      getUpdatedImageUrlWithSize(
                                        `${IMG_SERVER_URL}/brick-img/${i.id}.jpg`,
                                        [2, 2, 2],
                                      ),
                                    )
                                  : [Placeholder]
                              }
                            />
                            {/* </div> */}
                            <div
                              onClick={() => handleEditCollection(v)}
                              className="p-2 text-center absolute bottom-0 left-0  text-white text-sm sm:text-md md:text-xl font-semibold"
                            >
                              {v.name}{" "}
                            </div>
                          </div>
                        ))}
                      {/* </div> */}
                    </Masonry>
                  </ResponsiveMasonry>
                )}
              </>
            )}
          </ResponsiveMasonry>
        )}

        {/* Chakra UI Edit Modal */}
        <Modal
          isOpen={imagePopup.currentIdx !== null}
          onClose={() => setImagePopup({ currentIdx: null, images: [] })}
          size="6xl"
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>View Images</ModalHeader>
            <ModalCloseButton />
            <ModalBody overflow={"hidden"} display={"flex"}>
              <div className="flex items-center justify-between ">
                <Icon
                  icon={"uiw:left"}
                  width={"40"}
                  className="cursor-pointer"
                  onClick={() => {
                    if (imagePopup.currentIdx > 0) {
                      setImagePopup((prev) => ({
                        ...prev,
                        currentIdx: prev.currentIdx - 1,
                      }));
                    } else {
                      setImagePopup((prev) => ({
                        ...prev,
                        currentIdx: prev.images.length - 1,
                      }));
                    }
                  }}
                />
              </div>
              <div className="grow overflow-hidden  ">
                <ImgOptimized
                  src={getUpdatedImageUrlWithSize(
                    `${IMG_SERVER_URL}/brick-img/${
                      isAll?.images[imagePopup.currentIdx]?.id
                    }.jpg`,
                    [2, 3, 3],
                  )}
                  alt=""
                  // onClick={()=>setImagePopup({currentIdx: image.id, images: isAll.images})}
                  style={{
                    width: "100%",
                    height: "80vh",
                    // minHeight: "140px",
                    objectFit: "contain",
                    // borderRadius: "8px",
                  }}
                />
              </div>
              <div className="flex items-center justify-between  ">
                <Icon
                  icon={"uiw:right"}
                  width={"40"}
                  className="cursor-pointer"
                  onClick={() => {
                    setImagePopup((prev) => ({
                      ...prev,
                      currentIdx: (prev.currentIdx + 1) % prev.images.length,
                    }));
                  }}
                />
              </div>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    </Layout>
  );
};

const UserCard = ({ user, onClick }) => (
  <div
    onClick={onClick}
    className="cursor-pointer bg-white hover:bg-teal-50 border border-teal-200 shadow-sm rounded-xl px-6 py-4 mb-4 flex items-center gap-3 transition-all duration-200"
    style={{
      boxShadow: "0 2px 8px rgba(0, 128, 128, 0.08)",
    }}
  >
    <div className="flex items-center justify-center w-10 h-10 rounded-full bg-teal-100 text-teal-700 font-bold text-lg">
      {user?.[0]?.toUpperCase()}
    </div>
    <div className="flex-1 text-teal-900 font-semibold text-base">{user}</div>
    <Icon icon="mdi:arrow-right" width="22" className="text-teal-500" />
  </div>
);

export default Collections;
